import React, { useMemo } from 'react';
import classnames from 'classnames';
import { history } from 'umi';
import useIntlExtend from '@intelligence/hooks/useIntlExtend';
import GameImage from '@/pages/home/components/GameImage';
import CardSlot from '@/pages/intelligence/components/CardSlot';
import { getDetailGamePathCommon } from '@/pages/intelligence/utils/topchartsUtils';
import { PLACEHOLDER } from '@/pages/intelligence/pages/TopCharts/_config/topChartsConst';
import { getSourcesIcons, getMetricName, valueFormat } from '../utils';
import ARightClickToJump from '@/pages/intelligence/components/ARightClickToJump';
import type { IBaseProps, IGameType } from '@/pages/intelligence/types/common';
import type { IGameData } from '../types';
import { getGamesGenresTag } from '../../../../utils';

interface IGameItemProps extends IBaseProps {
  entityType: IGameType;
  game: IGameData;
}

const GameItem: React.FC<IGameItemProps> = (props) => {
  const { entityType, game } = props;
  // console.log('GameItem~~~~~~game', game);

  const { formatMessage } = useIntlExtend();

  const genres = useMemo(() => {
    if (!game) return [];
    return  getGamesGenresTag(game);
  }, [game]);

  const sourceIcons = getSourcesIcons(game?.source);

  const metricName = getMetricName({
    entityType,
    sources: game?.source,
    metric: game?.metric,
  });

  const getDetailGamePath = () =>
    getDetailGamePathCommon({
      entityType,
      gameId: game?.id,
      tab: 'overview',
    });

  const gotoGameDetailsPage = () => {
    const path = getDetailGamePath();
    history.push(path);
  };

  return (
    <CardSlot className="card-item">
      <ARightClickToJump
        href={getDetailGamePath()}
        style={{ display: 'inline' }}
      >
        <div className="games-item" onClick={gotoGameDetailsPage}>
          <div className="games-item-left">
            <GameImage
              entityType={entityType}
              src={game?.cover}
              className={classnames({
                // mobile
                'message-img-one': entityType === 'mobile',
                // pc
                'message-img-two': entityType === 'pc',
                // console
                'message-img-three': entityType === 'console',
              })}
            />
            <div className="message-text">
              <div className="text-title">{game?.name ?? PLACEHOLDER}</div>
              <div className="text-tip">
                {genres?.length > 0 || PLACEHOLDER}
                {genres?.length > 0 && (
                  <>
                    {genres?.map((item, idx: any) => (
                      <span className="tip-item" key={idx}>
                        {item}
                      </span>
                    ))}
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="games-item-right">
            <div className="message-text">
              {sourceIcons}
              <span className="text-tip">
                {formatMessage({ id: metricName })}
              </span>
            </div>
            <div className="text-num">
              {valueFormat(game?.total) ?? PLACEHOLDER}
            </div>
          </div>
        </div>
      </ARightClickToJump>
    </CardSlot>
  );
};

export default GameItem;
